var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomProduct(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6819 19.909H9.68188M20.3182 10.0908H11.3182H20.3182ZM13.7726 14.9999H9.68188H13.7726ZM20.3182 14.9999H16.2271H20.3182Z",
    stroke: "#8C837B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0909 11.3178C10.7687 11.3178 11.3182 10.7684 11.3182 10.0906C11.3182 9.41275 10.7687 8.86328 10.0909 8.86328C9.41312 8.86328 8.86365 9.41275 8.86365 10.0906C8.86365 10.7684 9.41312 11.3178 10.0909 11.3178Z",
    fill: "#8C837B",
    stroke: "#8C837B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9092 21.1362C20.587 21.1362 21.1364 20.5867 21.1364 19.9089C21.1364 19.2311 20.587 18.6816 19.9092 18.6816C19.2314 18.6816 18.6819 19.2311 18.6819 19.9089C18.6819 20.5867 19.2314 21.1362 19.9092 21.1362Z",
    stroke: "#8C837B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16.227C15.6778 16.227 16.2273 15.6775 16.2273 14.9997C16.2273 14.3219 15.6778 13.7725 15 13.7725C14.3222 13.7725 13.7727 14.3219 13.7727 14.9997C13.7727 15.6775 14.3222 16.227 15 16.227Z",
    stroke: "#8C837B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomProduct);
export default __webpack_public_path__ + "static/media/customProduct.2d2cacb93db3f05dea56a2965007f361.svg";
export { ForwardRef as ReactComponent };